import {
  AfterViewInit,
  Component, ElementRef,
  Injector,
  Optional, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler, APPLY_STYLES_TYPE, register } from "@wm/components-base";

const DEFAULT_CLS = 'app-card card app-panel';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-card',
  hostClass: DEFAULT_CLS,
};

@Component({
  selector: '[wmCard]',
  template: `
    <div class="app-card-header panel-heading" *ngIf="showHeader">
      <div class="app-card-avatar" *ngIf="iconclass || iconurl">
        <i class="app-icon" [ngClass]="iconclass" *ngIf="iconclass && !iconurl"></i>
        <img class="img-circle" [src]="iconurl" *ngIf="iconurl" />
      </div>
      <div class="app-card-header-text">
        <h4 class="card-heading" [textContent]="title"></h4>
        <h5 class="card-subheading text-muted" [textContent]="subheading"></h5>
      </div>
      <div class="panel-actions" *ngIf="actions">
        <i class="app-icon wm-sl-l sl-more-menu-vertical"></i>
      </div>
    </div>
    <div class="app-card-image" *ngIf="picturesource"  [ngStyle]="{'max-height':imageheight}">
      <img wmPicture class="card-image" [src]="picturesource" [title]="picturetitle" />
    </div>
    <div #cardContainerWrapper>
      <ng-content ngProjectAs="[wmCardContent]"></ng-content>
    </div>
  `,
  providers: [
    provideAsWidgetRef(CardComponent)
  ],
  exportAs: 'wmCard',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class CardComponent extends StylableComponent implements AfterViewInit{
  static initializeProps = register('wm-card');
  showHeader: any;
  iconclass: any;
  iconurl: any;
  title: any;
  subheading: any;
  actions: any;
  override picturesource: any;
  imageheight: any;
  picturetitle: any;


  @ViewChild('cardContainerWrapper', { static: true }) private cardContainerElRef: ElementRef;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.SHELL);
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    styler(this.cardContainerElRef.nativeElement, this, APPLY_STYLES_TYPE.INNER_SHELL);
  }

  override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'title' || key === 'subheading' || key === 'iconclass' || key === 'iconurl' || key === 'actions') {
      this.showHeader = !!(this.title || this.subheading || this.iconclass || this.iconurl || this.actions);
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }
}

